import Vuex from 'vuex'

import Vue from 'vue'
import { stat } from 'fs'

Vue.use(Vuex)

export default new Vuex.Store({
      state: {
            actualites: [],
            render: 0,
            info: [],
            infoSoc:[],
            proposals:[],
            invoices:[],
            contracts:[],
            orders:[],
            modalDoc:{},
            currentPropale:null,
            invoicesContracts:null
      },
      mutations: {
            getActualites(state){
                  return state.actualites;
            },
            setActualite(state, data){
                  state.actualites = data;
                  return state.actualites
            },
            addActualite(state, data){
                  state.actualites.push(data);
                  return state.actualites
            },
            rendering (state) {
                  state.render += 1
            },
            updateInfo(state, info) {
                  state.info = info
            },
            updateInfoSoc(state, info) {
                  state.infoSoc = info
            },

            addContract(state, contract){
                  let find = state.contracts.filter(element => element.id == contract.id)
                  if(find.length){
                        let index = state.contracts.findIndex(element => element.id == contract.id)
                        state.contracts[index] = contract
                  }else{
                        state.contracts.push(contract)
                  }
            },
            addProposal(state, proposal){
                  let find = state.proposals.filter(element => element.id == proposal.id)
                  if(find.length){
                        let index = state.proposals.findIndex(element => element.id == proposal.id)
                        state.proposals[index] = proposal
                  }else{
                        state.proposals.push(proposal)
                  }  
            },
            addInvoice(state, invoice){
                  let find = state.invoices.filter(element => element.id == invoice.id)
                  if(find.length){
                        let index = state.invoices.findIndex(element => element.id == invoice.id)
                        state.invoices[index] = invoice
                  }else{
                        state.invoices.push(invoice)
                  }
            },
            addOrder(state, order){
                  let find = state.orders.filter(element => element.id == order.id)
                  if(find.length){
                        let index = state.orders.findIndex(element => element.id == order.id)
                        state.orders[index] = order
                  }else{
                        state.orders.push(order)
                  }
            },

            delContract(state, id){
                  state.contracts = state.contracts.filter(contract => contract.id != id)
            },
            delProposal(state, id){
                  state.proposals = state.proposals.filter(proposal => proposal.id != id)
            },
            delInvoice(state, id){
                  state.invoices = state.invoices.filter(invoice => invoice.id != id)
            },
            delOrder(state, id){
                  state.orders = state.orders.filter(order => order.id != id)
            },

            resetDocuments(state){
                  state.proposals = []
                  state.invoices = []
                  state.contracts = []
                  state.orders = []
            },

            setModalDoc(state,data){
                  state.modalDoc = data
            },
            setCurrentPropale(state, data){
                  state.currentPropale = data
            },
            setInvoicesContracts(state, data){
                  state.invoicesContracts = data
            }
      }
})